import { Logo } from "./Logo";
import { scrollToId } from "../lib/site";
import { useContent } from "../context/ContentContext";

const LINKS = [
  { label: "Inicio", href: "#inicio" },
  { label: "Líneas", href: "#lineas" },
  { label: "Catálogo", href: "#catalogo" },
  { label: "Calidad", href: "#calidad" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Contacto", href: "#contacto" },
];

export default function Footer() {
  const content = useContent();
  const c = content.contact;

  return (
    <footer className="border-t border-black bg-obsidian" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="flex flex-col justify-between gap-10 lg:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-3 rounded-2xl bg-white px-4 py-3 w-fit">
              <Logo className="h-10 w-auto" />
            </div>
            <p className="mt-5 text-sm leading-relaxed text-neutral-400">
              Innovación que transforma la salud. Distribuidor oficial autorizado en
              República Dominicana de la Línea Landerlan, Silver, Gold y Diamond Series.
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-x-12 gap-y-3" data-testid="footer-nav">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId(l.href);
                }}
                data-testid={`footer-link-${l.href.slice(1)}`}
                className="text-sm text-neutral-400 transition-colors hover:text-brand-soft"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <div className="text-sm text-neutral-400">
            <p className="font-mono mb-3 text-[10px] uppercase tracking-[0.3em] text-neutral-500">
              Contacto
            </p>
            <p>{c.address}</p>
            <p className="mt-1">{c.phone}</p>
            <p className="mt-1 text-brand-soft">{c.email}</p>
          </div>
        </div>

        <p className="mt-12 border-t border-white/10 pt-8 text-[11px] leading-relaxed text-neutral-600">
          {content.footer_legal}
        </p>

        <p className="mt-12 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-600">
          © 2026 Landerlan Dominicana · Santo Domingo, República Dominicana
        </p>
      </div>
    </footer>
  );
}
